<template>
  <section>
    <div class="content_bg" :style="borderStyle" v-if="hasImages">
      <div class="content">
        <div class="content_core">
          <ul>
            <li v-for="(image, index) in record.detail_image_list" :key="index">
              <img class="wide_image" :src="image" />
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
  </template>
  
  <script>
import Caption from "./Caption.vue";
import CaptionGreen from "./CaptionGreen.vue";
import CaptionWhite from "./CaptionWhite.vue";
  
export default {
  props: ["record", "color"],
  components: {
    Caption,
    CaptionGreen,
    CaptionWhite,
  },
  computed: {
    hasImages() {
      return (
        this.record &&
        this.record.detail_image_list &&
        this.record.detail_image_list.length > 0
      );
    },
    borderStyle() {
      return {
        backgroundColor: this.color + "0F",
      };
    },
  },
};
  </script>
  
  <style scoped>
.content_bg {
  height: fit-content;
  display: flex;
  justify-content: center;
  background-color: #ffffff;
  position: relative;
}
  
.content {
  width: 100vw;
  height: 100%;
  max-width: 1140px;
  display: inline-block;
  padding-top: 50px;
  padding-bottom: 50px;
}
  
.content_core {
  margin-top: 60px;
  text-align: left;
  width: 1124px;
  max-width: 1124px;
  display: inline-block;
}
  
ul {
  width: 100%;
  list-style-type: none;
  padding-inline-start: 0px;
  margin: 0;
}
  
li {
  margin-bottom: 30px;
}
  
.wide_image {
  width: 100%;
  height: auto;
  border-radius: 6px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
}
  
@media screen and (max-width: 1440px) {
  .content_bg {
    height: fit-content;
  }
  
  .content {
    width: 100vw;
    height: fit-content;
    display: inline-block;
    position: relative;
    padding-top: 50px;
    padding-bottom: 50px;
    text-align: center;
  }
  
  .content_core {
    display: inline-block;
    height: fit-content;
    margin-left: 0px;
    margin-top: 0px;
    text-align: center;
    width: calc(100vw - 32px);
    max-width: 1124px;
    position: relative;
  }
  
  ul {
    width: 100%;
    text-align: center;
  }
  
  li {
    margin-bottom: 24px;
  }
}
  </style>
  

